module.exports = __webpack_public_path__ + "media/images/default/shared/header/bg-206abaad1589d74d48293a2383e70a67.svg";